<p-table
  dataKey="name"
  [value]="pois"
  [(selection)]="selectedPois"
  [tableStyle]="{ 'min-width': '50rem' }">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 1rem"></th>
      <th>POI</th>
      <th>Read / Write</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-poi>
    <tr>
      <td>
        <p-tableCheckbox [value]="poi"></p-tableCheckbox>
      </td>
      <td><i [class]="poi.icon"></i></td>
      <td>{{ poi.name }}</td>
      <td><p-inputSwitch (click)="accessToggle()"></p-inputSwitch></td>
    </tr>
  </ng-template>
</p-table>
